import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";

export default function ProfileDashboard() {
  return (
    <AppShell>
      <Dashboard />
    </AppShell>
  );
}
